import {RouterProps} from "../../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Post from "./Post";
import Detail from "./Detail";
import Edit from "./Edit";

export default function PurchaseOptionRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:assetLunarPurchaseOptionId'} element={<Detail {...props} />} />
            <Route path={'/:assetLunarPurchaseOptionId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}